import axios from '@/api/axios';

export async function getHolidays(year) {
  const result = await axios.get(`/holidays/list?year=${year}`);
  return result;
}

export async function deleteHoliday(date) {
  const response = await axios.post(`/holidays/deleteHoliday?date=${date}`);
  return response;
}

export async function addHoliday(date, holiday) {
  const data = await axios.post(`/holidays/addHoliday?date=${date}&holiday=${holiday}`);
  return data;
}
